/**
 * A dollar amount for an AI cost: four decimals under $0.10, so a single
 * small call does not read as $0.01; two at or above. Shared by the Review
 * header's AI cost line and the vendor profile cards and detail.
 */
export function formatAiCostUsd(usd) {
  const n = Number(usd) || 0;
  return n < 0.1 ? `$${n.toFixed(4)}` : `$${n.toFixed(2)}`;
}
